import React from "react";
import {Route, Routes} from "react-router-dom";
import Blacklists from "../pages/Blacklist/Blacklists";
import BuildersLanding from "../pages/Builders/BuildersLanding";
import CompanyDetailsForm from "../pages/Company/components/CompanyDetailsForm";
import Comparison from "../pages/Comparison/Comparison";
import ETFMatrix from "../pages/EtfMatrix/EtfMatrix";
import FactSheet from "../pages/Portfolio/FactSheet/FactSheet";
import Files from "../pages/Files/Files";
import {default as PortfolioFormBuilder} from "../pages/FormBuilder/FormBuilder";
import Dashboard from "../pages/Dashboard";
import NewsCollection from "../pages/News/NewsCollection";
import PerformanceComparison from "../pages/PerformanceComparison/PerformanceComaprison";
import PortfolioBuilder from "../SuperComponents/PortfolioBuilder/PortfolioBuilder";
import PortfoliosCollection from "../pages/Portfolio/PortfoliosCollection";
import PortfolioPages  from "../pages/Portfolio/PortfolioPages/PortfolioPages";
import PageViewHistory from "../pages/Portfolio/PortfolioPages/PageViewHistory";
import PortfolioPagePublicEntrypoint from "../pages/PublicPages/PortfolioPagePublicEntrypoint";
import PortfolioSignals from "../pages/TradingSignals/components/PortfolioSignals";
import PortfolioView from "../pages/PortfolioView/PortfolioView";
import Resources from "../pages/Resources/Resources";
import Screens from "../pages/Screens/Screens";
import Settings from "../pages/Settings/Settings";
import Sma from "../pages/SmaV2/Sma";
import Snapshots from "../pages/TradingSignals/Snapshots/Snapshots";
import SuperUser from "../pages/SuperUser/SuperUser";
import TradingSignals from "../pages/TradingSignals/TradingSignals";
import TickerView    from "../pages/TickerView/TickerView";
import TickerCalendar from "../pages/TickerCalendar/TickerCalendar";



import GeneralStockChart from "../SuperComponents/StockCharts/GeneralStockChart";
import TickerLauncher from "../pages/Experiments/TickerLauncher";

import FactorView from "../pages/Experiments/FactorView";

import Xray from "../pages/Xray/Xray";
import PortfolioPaths from "../pages/PortfolioPath/PortfolioPaths";
import PortfolioViewsLauncher from "../pages/Experiments/PortfolioViewsLauncher";
import ChartLauncher from "../pages/Experiments/ChartLauncher";
import ChartViews from "../pages/Experiments/ChartViews";

import Terminology from "../pages/Experiments/Terminology";
import ChatBox from "../modules/Inference/Chatbox/ChatBox";

import PathStepper from "../pages/PortfolioPath/PathStepper/PathStepper";
import PathSummary from "../pages/PortfolioPath/PathSummary/PathSummary";
import PortfolioPathResults from "../pages/PortfolioPath/PathSummary/PortfolioPathResults";
import PathEditor from "../pages/PortfolioPath/PathEditor/PathEditor";
import HedgeFunds from "../pages/Experiments/HedgeFunds/HedgeFunds";
import HedgeFund from "../pages/Experiments/HedgeFunds/HedgeFund/HedgeFund";

import PortfolioExchange from "../pages/PortfolioExchange/PortfolioExchange";
import ExchangeView from "../pages/PortfolioExchange/ExchangeView";

import Company from "../pages/Company/Company";
import PathManager from "../pages/Company/PathManager/PathManager";
import TimeCover from "../pages/Experiments/TimeCovers";
import DashboardMinimal from "../pages/Dashboard/DashboardMinimal";
import ApplicationManager from "../pages/ApplicationManager";
import NewsAndEvents from "../pages/Dashboard/NewsAndEvents";


import ClientPortfolios from "../pages/Portfolio/ClientPortfolios";
import ClientsView from "../pages/Clients/ClientsView";
import ClientFormPage from "../pages/Clients/ClientFormPage";
import ClientDashboard from "../pages/Clients/ClientDashboard";


import AnalysisOptions from "../features/analysis/AnalysisOptions";
import ClusterAnalysis   from "../features/analysis/ClusterAnalysis";
export const PublicRoutes = () => {
    return (
            <Routes>
                {/* Define public routes here */}
                <Route path="/public/portfolio/:portfolioId" element={<PortfolioView/>}/>
                <Route path="/public/etfs/matrix" exact element={<ETFMatrix/>}/>
                <Route path={'/public/pages/:pageId'} element={<PortfolioPagePublicEntrypoint/>} />
                <Route path={'/public/etf-matrix'} element={<ETFMatrix/>}/>
                <Route path={'/public/resources'} element={<Resources/>}/>
                <Route path={'/public/builders/sma'} element={<Sma/>}/>
                <Route path={'/public/beta/comparison'} exact element={<Comparison/>} />


                {/* You can add more public routes as needed */}
            </Routes>
    )
}


export const IAPlatformRoutes = ({widgets}) => {
    return (
        <Routes>
            <Route path="/"  exact element={<DashboardMinimal />} />
            <Route path="/apps" element={<ApplicationManager widgets={widgets} />} />
            <Route path="/builders/landing" exact element={<BuildersLanding />} />
            <Route path="/builders/portfolio" exact element={<PortfolioBuilder />} />
            <Route path="/builders/model" exact element={<PortfolioFormBuilder />} />
            <Route path="/builders/sma" exact element={<Sma />} />


            <Route path="/calendar" element={<TickerCalendar/>} />

            <Route path="/clients" exact element={<ClientsView/>} />
            <Route path="/clients/create" element={<ClientFormPage />} />
            <Route path="/clients/:clientId/edit" element={<ClientFormPage />} />
            <Route path="/clients/view/:clientId" element={<ClientDashboard />} />

            <Route path="/company" exact element={<Company/>} />
            <Route path="/company/paths/pages" exact element={<PathManager/>} />
            <Route path={"/company/details/edit"} exact element={<CompanyDetailsForm/>} />

            <Route path={'/research/home'} exact element={<NewsAndEvents/>} />

            <Route path="/etfs/matrix" exact element={<ETFMatrix />} />

            <Route path="/files" exact element={<Files/>} />
            <Route path='/markets/factors' element={<FactorView/>} />

            <Route path="/news" exact element={<NewsCollection />} />


            <Route path={'/inference/chat'} element={<ChatBox/>} />

            <Route path="/beta/analysis/options" exact element={<AnalysisOptions />} />
            <Route path="/beta/analysis/cluster" exact element={<ClusterAnalysis />} />

            <Route path="/pages" exact element={<PortfolioPages />} />
            <Route path="/pages/:pageId/views" element={<PageViewHistory />} />


            <Route path="/portfolios" element={<PortfoliosCollection />} />
            <Route path="/portfolios/clients" element={<ClientPortfolios />} />
            <Route path={'/portfolios/exchange'} element={<PortfolioExchange/>} />
            <Route path={'/portfolios/exchange/:exchangeId'} element={<ExchangeView/>} />

            <Route path={'/portfolios/paths'} exact element={<PortfolioPaths/>} />
            <Route path="/portfolios/paths/:pathId/edit" element={<PathEditor/>} />
            <Route path="/portfolios/paths/:pathId/use" element={<PathStepper/>} />
            <Route path="/portfolios/paths/summary" element={<PathSummary/>} />
            <Route path="/portfolios/paths/results" element={<PortfolioPathResults/>} />
            <Route path="/portfolio/:portfolioId" element={<PortfolioView />} />
            <Route path="/portfolio/:portfolioId/factsheet" element={<FactSheet />} />




            <Route path="/signals" exact element={<TradingSignals />} />
            <Route path="/signals/:portfolioId" element={<PortfolioSignals />} />
            <Route path="/signals/:portfolioId/history" element={<Snapshots />} />

            <Route path="/performance/comparison" exact element={<PerformanceComparison />} />
            <Route path={'/resources'} exact element={<Resources/>}/>
            <Route path="/screener" exact element={<Screens />} />
            <Route path="/settings" exact element={<Settings />} />

            <Route path="/widgets/blacklist" exact element={<Blacklists />} />

            <Route path="/superuser" exact element={<SuperUser />} />
            <Route path="/tickers/:ticker" exact element={<TickerView/>} />

            <Route path="/experiments/home" element={<TickerLauncher/>} />
            <Route path={'/experiments/charts/launcher' } element={<ChartLauncher/>} />

            <Route path={'/beta/comparison'} exact element={<Comparison/>} />
            <Route path={'/beta/general/chart'} exact element={<GeneralStockChart/>} />
            <Route path="/beta/hedgefunds" element={<HedgeFunds/>} />
            <Route path="/beta/hedgefunds/:hedgefundName" element={<HedgeFund/>} />
            <Route path={'/beta/terminology'} element={<Terminology/>} />
            <Route path={'/beta/charts/:symbol'} element={<ChartViews/>} />
            <Route path="/beta/xray" element={<Xray/>} />
            <Route path={'/beta/portfolios/views'} element={<PortfolioViewsLauncher/>} />
            <Route path={'/beta/time-covers'} element={<TimeCover assetKey={'timeMagazine'}/>} />
        </Routes>
    )
};


